export default "__VITE_ASSET__60da1820__"